
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { checkStatus, checkStatusCliente, loginClienteService, loginService } from "../../services";

import Swal from "sweetalert2";




const storeApi = (set, get) => ({

    status: 'unauthorized',
    usuario: undefined,
    menuData: [],
    token: undefined,
    cliente: null,
    tokenCliente: undefined,


    
    startEditarPerfil: (usuarioActualizado) => {
        const { token, ...usuarioSinToken } = usuarioActualizado;
        set((state) => ({ ...state, usuario: { ...state.usuario, ...usuarioSinToken } }));
    },


    startEditarPerfilCliente: (usuarioActualizado) => {
        const { token, ...usuarioSinToken } = usuarioActualizado;
        set((state) => ({ ...state, cliente: { ...state.cliente, ...usuarioSinToken } }));
    },


    startLoginUser: async(login) => {
        try {
            const { token, usuario, menu } = await loginService(login);
            set({ status: 'authorized', token, usuario, menuData: menu });
            return true;
        } catch (error) {
            set({status: 'unauthorized', token: undefined, usuario: undefined});
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },


    startLoginCliente: async(login) => {
        try {
            const { token, usuario } = await loginClienteService(login);
            set({ cliente:usuario, tokenCliente:token });
            Swal.fire('Exitoso', 'Ingreso Exitoso', 'success');
            return true;
        } catch (error) {
            set({status: 'unauthorized', token: undefined, usuario: undefined});
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },


    startCheckStatus: async() => {
        if( !get().token ){ return get().startLogout() }
        try {
            const { token, usuario, menu } = await checkStatus();
            set({ status: 'authorized', token, usuario, menuData: menu });
        } catch (error) {
            set({status: 'unauthorized', token: undefined, usuario: undefined});
        }
    },


    startCheckStatusCliente: async() => {
        if( !get().tokenCliente ) return get().startLogoutCliente();
        try {
            const { token, usuario } = await checkStatusCliente();
            set({ tokenCliente: token, cliente: usuario });
        } catch (error) {
            set({ tokenCliente: undefined, cliente: undefined });
        }
    },


    startLogout: () => {
        set({status: 'unauthorized', token: undefined, usuario: undefined, menuData: [] });
    },


    startLogoutCliente: () => {
        set({ cliente: undefined, tokenCliente: undefined });
    },



});




export const useAuthStore = create(
    devtools(
        persist(
            storeApi,
            { name: 'auth-storage' }
        )
    )
)
